import { ConfirmationPopUpService } from 'src/app/services/confirmation-pop-up.service';
import { SettingsService } from 'src/app/pages/settings/settings.service';

import { TemplateProjectTaskPopupComponent } from './../../task/template-project-task-popup/template-project-task-popup.component';
import { TemplateProjectTask } from './../project.service';
import { Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';

import { HelpService } from '../../help/help.service';
import { TaskService } from '../../task/task.service';
import { Dependency, ProjectService, Resource, ResourceAssignment, TemplateProject } from '../project.service';
import { Location } from '@angular/common';
import { DxGanttComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { AuthService } from 'src/app/services';
import { InfoBoxService } from 'src/app/services/info-box.service';

@Component({
    selector: 'app-project-templates',
    templateUrl: './project-templates.component.html',
    styleUrls: ['./project-templates.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProjectTemplatesComponent implements OnInit {
	public reload: boolean = true;

	private _reload() {
		setTimeout(() => this.reload = false);
		setTimeout(() => this.reload = true);
	}

	public reloadTaskPopupValue: boolean = true;

	public reloadTaskPopup() {
		setTimeout(() => this.reloadTaskPopupValue = false);
		setTimeout(() => this.reloadTaskPopupValue = true);
	}

	private _infoBoxService: InfoBoxService = inject(InfoBoxService);

	public tasksInitialized: boolean;
	public templateTasks: TemplateProjectTask[] = [];
	public dependencies: Dependency[] = [];
	public resources: Resource[] = [];
	public resourceAssignments: ResourceAssignment[] = [];

	private templateProjectsSelectBoxPaginated: boolean;
	@ViewChild("templateProjectsSelectBox", { static: false }) set templateProjectsSelectBoxComponent(component: DxSelectBoxComponent) {
		if (component && !this.templateProjectsSelectBoxPaginated) {
			
			this.templateProjectsSelectBoxPaginated = true;

			component.instance.getDataSource().paginate(true);
		}
	};
	public templateProjects: TemplateProject[] = [];

	public currentlySelectedTask: TemplateProjectTask = new TemplateProjectTask();

	// <General page fields>
	private readonly _componentTitle = "Project Templates";
	private readonly _templateProjectIdQueryParamName = "id";
	// private readonly _QueryParamName = "NONE";
	// </General page fields>

	public showTaskPopup: boolean = false;

	public userNames: string[];

	@ViewChild('gantt', { static: false }) ganttComponent: DxGanttComponent;
	@ViewChild('taskPopup', { static: false }) taskPopupComponent: TemplateProjectTaskPopupComponent;

	constructor(
		private titleService: Title,
		private notificationService: NotificationService,
		private projectService: ProjectService,
		private helpService: HelpService,
		private route: ActivatedRoute,
		private location: Location,
		private taskService: TaskService,
		public authService: AuthService,

		private _settingsService: SettingsService,
		private _confirmationPopUpService: ConfirmationPopUpService,
	) { }

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		const $this = this;

		this.initializeTemplateProjects().then(
			(response) => {
				$this.route.queryParamMap.subscribe(
					(queryParams) => {
						let id: number = +queryParams.get($this._templateProjectIdQueryParamName);

						if (!id && $this.templateProjects.length > 0) {
							id = $this.templateProjects[0].Id;
						}

						console.log(`ngOnInit-> initializeActivitiesObjectClientIds - ${$this._templateProjectIdQueryParamName}:`, id);

						$this.selectTemplateProject(id);
					}
				);
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	private assignResourceToTask(templateProjectTask: TemplateProjectTask) {
		

		let resourceAssignment: ResourceAssignment = new ResourceAssignment();

		if (Number.isNaN(Number(templateProjectTask.id))) {
			resourceAssignment.id = templateProjectTask.newIdToReplaceAutogeneratedGUID;
			
		} else {
			resourceAssignment.id = templateProjectTask.id;
		}

		resourceAssignment.taskId = templateProjectTask.id;

		let resource: Resource = this.resources.find(resource => resource.text === templateProjectTask.responsibleUser);

		if (resource) {
			resourceAssignment.resourceId = resource.id;
		} else {
			console.error("Coulnd't find resource that would match user responsible for this task. templateProjectTask:", templateProjectTask, "resources:", this.resources);
		}

		this.resourceAssignments.push(resourceAssignment);
	}

	private assignResourcesToTasks(templateProjectTasks: TemplateProjectTask[]) {
		this.resourceAssignments = [];

		for (let a = 0; a < templateProjectTasks.length; a++) {
			const task = templateProjectTasks[a];

			this.assignResourceToTask(task);
		}
	}

	private updateResourceAssignmentOfTask(templateProjectTask: TemplateProjectTask) {
		let resourceAssignment: ResourceAssignment = this.resourceAssignments.find(innerResourceAssignment => innerResourceAssignment.taskId === templateProjectTask.id);

		if (resourceAssignment) {
			resourceAssignment.resourceId = this.resources.find(resource => resource.text === templateProjectTask.responsibleUser).id;
		}
	}

	public directionItems: { name: string, value: number }[] = [
		{
			name: "Ascending",
			value: 1
		},
		{
			name: "Descending",
			value: -1
		}
	];
	public selectedDirectionItem: { name: string, value: number } = this.directionItems[0];

	public onDirectionItemChanged(event: any) {
		console.log("onDirectionItemChanged - event:", event);

		this.refreshGanttChart();
	}

	public sortingItems: { name: string, sortRule: (a: TemplateProjectTask, b: TemplateProjectTask, directionValue: number) => number }[] = [
		{
			name: "Subject",
			sortRule: (a: TemplateProjectTask, b: TemplateProjectTask, directionValue: number) => {
				return ('' + a.templateTaskName).localeCompare(b.templateTaskName) * directionValue;
			}
		},
		{
			name: "Start Date",
			sortRule: (a: TemplateProjectTask, b: TemplateProjectTask, directionValue: number) => {
				if (a.startDate > b.startDate) return 1 * directionValue;
				if (a.startDate < b.startDate) return -1 * directionValue;

				return 0;
			}
		},
		{
			name: "End Date",
			sortRule: (a: TemplateProjectTask, b: TemplateProjectTask, directionValue: number) => {
				if (a.deadlineDate > b.deadlineDate) return 1 * directionValue;
				if (a.deadlineDate < b.deadlineDate) return -1 * directionValue;

				return 0;
			}
		},
		// {
		// 	name: "Progress",
		// 	sortRule: (a: TemplateProjectTask, b: TemplateProjectTask, directionValue: number) => {
		// 		return (a.progress - b.progress) * directionValue;
		// 	}
		// },
	];
	public selectedSortingItem: { name: string, sortRule: (a: TemplateProjectTask, b: TemplateProjectTask, directionValue: number) => number } = this.sortingItems[0];

	public onSortingItemChanged(event: any) {
		console.log("onSortingItemChanged - event:", event);

		this.refreshGanttChart();
	}

	public refreshGanttChart() {
		this.templateTasks.sort((a, b) => this.selectedSortingItem.sortRule(a, b, this.selectedDirectionItem.value));

		//? Force gantt chart update to reflect these changes of the task.
		if (this.templateTasks.length > 2) { // 2 - is a magic number after which gantt starts acting normally with css.
			this.templateTasks = [...this.templateTasks]; //?! This update looks nicer, but if it creates too much garbage stick with `instance.repaint`.
		} else {
			this.ganttComponent.instance.repaint();
		}
	}

	private initializeGanttChartData(templateProject: TemplateProject) {
		console.log("initializeGanttChartData - templateProject:", templateProject);

		const $this = this;

		//? Initialize dependencies.

		this.projectService.getTemplateProjectTaskDependencies(
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {
					

					$this.dependencies = $this.projectService.convertProjectTaskDependenciesToDependencies(response);
				}
			}
		);

		//? Get tasks of a project template.

		this.tasksInitialized = false;
		this.projectService.getTemplateProjectTasks(
			templateProject.Id,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {
					

					$this.templateTasks = [];

					for (let a = 0; a < response.length; a++) {
						const templateTaskData = response[a];

						let templateTask: TemplateProjectTask = Object.assign(new TemplateProjectTask(), templateTaskData, { parentTemplateTaskId: templateTaskData.parentTemplateTaskId ? templateTaskData.parentTemplateTaskId : 0 });
						templateTask.initialize(templateProject);

						$this.templateTasks.push(templateTask);
					}

					this.taskService.getUserList(
						{
							showLoadingIndicator: true,
						}
					).subscribe(
						{
							next: (userNames) => {
								

								$this.userNames = userNames;

								$this.resources = [new Resource(0, "Not Assigned")];

								for (let a = 0; a < userNames.length; a++) {
									const userName = userNames[a];

									let resource: Resource = new Resource();

									resource.id = a + 1;
									resource.text = userName;

									$this.resources.push(resource);
								}

								$this.assignResourcesToTasks($this.templateTasks);

								$this.tasksInitialized = true;

								$this.refreshGanttChart();
							}
						}
					);
				}
			}
		);
	}

	private initializeTemplateProjects() {
		const observable$ = this.projectService.getTemplateProjects(
			{
				showLoadingIndicator: true,
			}
		);

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				

				$this.templateProjects = response;

				if ($this.templateProjects.length < 1) {
					console.warn("Didn't receive any objects, thus couldn't select a default object to display.");
				}
			}
		);
	}

	public selectedTemplateProject: TemplateProject;
	public selectedTemplateProjectDisplay: TemplateProject;

	public selectTemplateProject(templateProjectId: number, forceUpdate: boolean = false) {
		

		//? Try to find project template in cached array of project templates before sending a request.
		this.selectedTemplateProject = this.templateProjects.find((templateProject) => templateProject.Id === templateProjectId);

		if (!forceUpdate && this.selectedTemplateProject) {
			

			this.selectedTemplateProjectDisplay = Object.assign(new TemplateProject(), this.selectedTemplateProject);

			this.initializeGanttChartData(this.selectedTemplateProjectDisplay);

			const url = `general/project-templates?${this._templateProjectIdQueryParamName}=${this.selectedTemplateProject.Id}`;
			this.location.replaceState(url);

			return;
		}

		this.projectService.getTemplateProject(
			templateProjectId,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {
					

					this.selectedTemplateProject = response;
					this.selectedTemplateProjectDisplay = Object.assign(new TemplateProject(), this.selectedTemplateProject);

					const selectedTemplateProjectIndex = this.templateProjects.findIndex((templateProject) => templateProject.Id === this.selectedTemplateProject.Id);

					if (selectedTemplateProjectIndex >= 0) {
						this.templateProjects[selectedTemplateProjectIndex] = this.selectedTemplateProject;
					}

					this.initializeGanttChartData(this.selectedTemplateProjectDisplay);

					const url = `general/project-templates?${this._templateProjectIdQueryParamName}=${this.selectedTemplateProject.Id}`;
					this.location.replaceState(url);

					
				}
			}
		);
	}

	public onTemplateProjectSuccessfullyCreated(id: number) {
		

		this.initializeTemplateProjects().then(
			(response) => {
				

				this.selectTemplateProject(id);
			}
		);
	}

	public createTemplateProject(event: any) {
		

		this.projectService.createTemplateProject(
			event.primaryValue,
			{
				showLoadingIndicator: true,
				showErrorNotification: false,
			}
		).subscribe(
			{
				next: (response) => {
					

					this._infoBoxService.show(
						{
							message: response.message
						}
					);

					if (response.success) {
						this.templateProjectPopUpVisible = false;

						this.onTemplateProjectSuccessfullyCreated(response.id);
					}
				},
				error: (error) => {
					// If it's a conflict.
					if (error.status === 409 && !error.error.success) {
						this._infoBoxService.show(
							{
								message: error.error.message
							}
						);
					} else {
						this.notificationService.error(error);
					}
				}
			}
		);
	}

	public cloneTemplateProject(event: any) {
		

		this.projectService.cloneTemplateProject(
			event.primaryValue,
			this.selectedTemplateProject.Id,
			{
				showLoadingIndicator: true,
				showErrorNotification: false,
			}
		).subscribe(
			{
				next: (response) => {
					

					this._infoBoxService.show(
						{
							message: response.message
						}
					);

					if (response.success) {
						this.templateProjectPopUpVisible = false;

						this.onTemplateProjectSuccessfullyCreated(response.id);
					}
				},
				error: (error) => {
					// If it's a conflict.
					if (error.status === 409 && !error.error.success) {
						this._infoBoxService.show(
							{
								message: error.error.message
							}
						);
					} else {
						this.notificationService.error(error);
					}
				}
			}
		);
	}

	public updateTemplateProject(templateProject: TemplateProject) {
		

		this.projectService.updateTemplateProject(
			templateProject,
			{
				showLoadingIndicator: false,
				showErrorNotification: false
			}
		).subscribe(
			{
				next: (response) => {
					

					this._infoBoxService.show(
						{
							message: response.message
						}
					);

					this.selectTemplateProject(response.id, true);

					
				},
				error: (error) => {
					// If it's a conflict.
					if (error.status === 409 && !error.error.success) {
						this._infoBoxService.show(
							{
								message: error.error.message
							}
						);
					} else {
						this.notificationService.error(error);
					}
				}
			}
		);
	}

	public deleteTemplateProject(templateProject: TemplateProject) {
		

		this.projectService.deleteTemplateProject(
			templateProject,
			{
				showLoadingIndicator: false,
				showErrorNotification: false,
			}
		).subscribe(
			{
				next: (response) => {
					

					this._infoBoxService.show(
						{
							message: response.message
						}
					);

					this.templateProjects.splice(this.templateProjects.findIndex((tmpProj) => tmpProj.Id === templateProject.Id), 1);

					if (this.templateProjects.length > 0) {
						this.selectTemplateProject(this.templateProjects[0].Id);
					}

					
				},
				error: (error) => {
					// If it's a conflict.
					if (error.status === 409 && !error.error.success) {
						this._infoBoxService.show(
							{
								message: error.error.message
							}
						);
					} else {
						this.notificationService.error(error);
					}
				}
			}
		);
	}

	public makeProjectMain: boolean = true;

	public createProjectFromTemplate(event: any) {
		

		this.projectService.createProjectFromTemplate(
			this.selectedTemplateProject.Id,
			event.primaryValue,
			event.secondaryValue,
			event.tetriaryValue,
			{
				showLoadingIndicator: true,
				showErrorNotification: false,
			}
		).subscribe(
			{
				next: (response) => {


					this._infoBoxService.show(
						{
							message: response.message
						}
					);

					if (response.success) {
						this.createProjectPopUpVisible = false;

						if (this.makeProjectMain) {
							this._settingsService.setCoreSetting(
								null,
								"MainProjectId",
								response.id,
								{
									showLoadingIndicator: true,
								}
							).subscribe();
						}
					}
				},
				error: (error) => {
					// If it's a conflict.
					if (error.status === 409 && !error.error.success) {
						this._infoBoxService.show(
							{
								message: error.error.message
							}
						);
					} else {
						this.notificationService.error(error);
					}
				}
			}
		);
	}

	private hasChildren(task: TemplateProjectTask): boolean {
		for (let a = 0; a < this.templateTasks.length; a++) {
			const element = this.templateTasks[a];

			if (element.parentTemplateTaskId && element.parentTemplateTaskId === task.id) {
				return true;
			}
		}

		return false;
	}

	public currentPopUpTaskHasChildren: boolean;

	public onTaskClick(event: any) {
		console.log("onTaskClick - event:", event);

		this.currentlySelectedTask = this.templateTasks.find(task => task.id === event.key);
	}

	public onTaskDblClick(event: any) {
		console.log("onTaskDblClick - event:", event);

		event.cancel = true;

		let task: TemplateProjectTask = event.data as TemplateProjectTask;

		this.currentPopUpTaskHasChildren = this.hasChildren(task);
		this.showTaskPopup = true;
		this.taskPopupComponent.setDefaultValuesIfNone();
	}

	public onDependencyDeleted(event: any) {
		console.log("onDependencyDeleted", event);

		let dependency = event.values as Dependency;

		if (Number.isNaN(Number(dependency.id))) {
			dependency.id = -1;
		}

		if (Number.isNaN(Number(dependency.predecessorId))) {
			let task = this.templateTasks.find(task => task.id === dependency.predecessorId);

			if (task) {
				dependency.predecessorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		if (Number.isNaN(Number(dependency.successorId))) {
			let task = this.templateTasks.find(task => task.id === dependency.successorId);

			if (task) {
				dependency.successorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}



		this.projectService.deleteTemplateProjectTaskDependency(
			dependency,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {

				}
			}
		);
	}

	public onDependencyInserted(event: any) {
		console.log("onDependencyInserted", event);

		let dependency = event.values as Dependency;

		if (Number.isNaN(Number(dependency.id))) {
			dependency.id = -1;
		}

		if (Number.isNaN(Number(dependency.predecessorId))) {
			let task = this.templateTasks.find(task => task.id === dependency.predecessorId);

			if (task) {
				dependency.predecessorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		if (Number.isNaN(Number(dependency.successorId))) {
			let task = this.templateTasks.find(task => task.id === dependency.successorId);

			if (task) {
				dependency.successorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		this.projectService.insertTemplateProjectTaskDependency(
			dependency,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {

				}
			}
		);
	}

	public onResourceUnassigned(event: any) {
		console.log("onResourceUnassigned", event);

		let resourceAssignment = event.values as ResourceAssignment;

		if (Number.isNaN(Number(resourceAssignment.id))) {
			resourceAssignment.id = -1;
		}

		let resource: Resource = this.resources.find((innerResource) => innerResource.id === resourceAssignment.resourceId);

		if (resource.newId > 0) {
			resourceAssignment.resourceId = resource.newId;
		}



		




	}

	public onResourceAssigned(event: any) {
		console.log("onResourceAssigned", event);

		



		


	}

	private resourcesToBeDeleted: Resource[] = [];

	public onResourceDeleted(event: any) {
		console.log("onResourceDeleted", event);

		let resource: Resource = this.resourcesToBeDeleted.find((innerResource) => innerResource.id === event.key);

		if (resource.newId > 0) {
			resource.id = resource.newId;
		}

		


	}

	public onResourceDeleting(event: any) {
		console.log("onResourceDeleting", event);

		let resource: Resource = this.resources.find((innerResource) => innerResource.id === event.key);

		this.resourcesToBeDeleted.push(resource);
	}

	public onResourceInserted(event: any) {
		console.log("onResourceInserted", event);

		

		

		


	}

	private tasksToBeDeleted: TemplateProjectTask[] = [];

	public onTaskDeleted(event: any) {


		let templateTask: TemplateProjectTask = this.tasksToBeDeleted.find((innerTask) => innerTask.id === event.key);

		if (templateTask.newIdToReplaceAutogeneratedGUID > 0) {
			templateTask.id = templateTask.newIdToReplaceAutogeneratedGUID;
		}

		let taskParentIndex: number = this.templateTasks.findIndex((innerTask) => innerTask.id === templateTask.parentTemplateTaskId);

		if (taskParentIndex >= 0 && this.templateTasks[taskParentIndex].newIdToReplaceAutogeneratedGUID > 0) {
			templateTask.parentTemplateTaskId = this.templateTasks[taskParentIndex].newIdToReplaceAutogeneratedGUID;
		} else if (Number.isNaN(Number(templateTask.parentTemplateTaskId))) {
			templateTask.parentTemplateTaskId = 0;
		}

		this.projectService.deleteTemplateProjectTask(
			templateTask,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {

				}
			}
		);
	}

	public onTaskDeleting(event: any) {


		let templateTask: TemplateProjectTask = this.templateTasks.find((innerTask) => innerTask.id === event.key);

		this.tasksToBeDeleted.push(templateTask);
	}

	public onTaskInserted(event: any) {
		console.log("onTaskInserted", event);



		let insertedTaskIndex: number = this.templateTasks.findIndex((innerTask) => innerTask.id === event.key);
		let insertedTaskParentIndex: number = this.templateTasks.findIndex((innerTask) => innerTask.id === this.templateTasks[insertedTaskIndex].parentTemplateTaskId);


		let templateTask: TemplateProjectTask = Object.assign(new TemplateProjectTask(), this.templateTasks[insertedTaskIndex]);



		if (insertedTaskParentIndex < 0) {
			this.templateTasks[insertedTaskIndex].parentTemplateTaskId = 0;
			templateTask.parentTemplateTaskId = 0;
		} else {
			if (Number.isNaN(Number(templateTask.parentTemplateTaskId))) {
				templateTask.parentTemplateTaskId = this.templateTasks[insertedTaskParentIndex].newIdToReplaceAutogeneratedGUID;
			}

			let parentTaskResourceAssigmentIndex = this.resourceAssignments.findIndex((resourceAssigment) => resourceAssigment.taskId === this.templateTasks[insertedTaskParentIndex].id);

			if (parentTaskResourceAssigmentIndex >= 0) {
				this.resourceAssignments.splice(parentTaskResourceAssigmentIndex, 1); // Remove responsible user from parent task.
			}
		}

		this.templateTasks[insertedTaskIndex].link = this.location.path()
		templateTask.link = this.templateTasks[insertedTaskIndex].link;

		this.templateTasks[insertedTaskIndex].progress = 0;
		templateTask.progress = 0;

		this.templateTasks[insertedTaskIndex].templateProjectId = this.selectedTemplateProjectDisplay.Id;
		templateTask.templateProjectId = this.selectedTemplateProjectDisplay.Id;

		this.templateTasks[insertedTaskIndex].responsibleUser = this.authService.currentUserName;
		templateTask.responsibleUser = this.authService.currentUserName;

		this.templateTasks[insertedTaskIndex].taskStartDaysFromProjectStartDate = 0;
		templateTask.taskStartDaysFromProjectStartDate = 0;
		this.templateTasks[insertedTaskIndex].taskDeadlineDaysFromTaskStart = 5;
		templateTask.taskDeadlineDaysFromTaskStart = 5;

		templateTask.initialize(this.selectedTemplateProject);

		// It's necessary because it's missing `initialize` method otherwise.
		this.templateTasks[insertedTaskIndex] = Object.assign(new TemplateProjectTask(), this.templateTasks[insertedTaskIndex]);
		this.templateTasks[insertedTaskIndex].initialize(this.selectedTemplateProject);

		templateTask.prepareForCreation(this.selectedTemplateProject);

		this.projectService.createTemplateProjectTask(
			templateTask,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {


					if (response.success) {


						this.templateTasks[insertedTaskIndex].newIdToReplaceAutogeneratedGUID = response.id;

						this.assignResourceToTask(this.templateTasks[insertedTaskIndex]);

						this.refreshGanttChart();

						this.resourceAssignments = [...this.resourceAssignments];
					}
				},
				error: (error) => {
					this.templateTasks.splice(insertedTaskIndex, 1);

					this.refreshGanttChart();
				}
			}
		);
	}

	public onTaskUpdated(event: any) {


		let templateTask: TemplateProjectTask = Object.assign(new TemplateProjectTask(), this.templateTasks.find((innerTask) => innerTask.id === event.key), event.values);

		templateTask.prepareForUpdate(this.selectedTemplateProject, this.templateTasks);

		this.projectService.updateTemplateProjectTask(
			templateTask,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {

				}
			}
		);
	}

	// <Misc>

	public onUploadClick(event: any) {
		

		this.updateTemplateProject(this.selectedTemplateProjectDisplay);
	}

	public onTrashClick(event: any) {
		

		const defaultConfirmationPopUp = this._confirmationPopUpService.getPreset(ConfirmationPopUpService.ConfirmationPopUpPresetType.DEFAULT);

		

		defaultConfirmationPopUp.buttonsData[0].onClick.subscribe(
			() => this.deleteTemplateProject(this.selectedTemplateProjectDisplay)
		);

		

		this._confirmationPopUpService.show(defaultConfirmationPopUp);
	}

	public onProjectChanged(event: any) {
		

		let projectId: number = event.value;
		let previousProjectId: number = event.previousValue;

		if (projectId != previousProjectId) {
			this.selectTemplateProject(projectId);
		}
	}

	public templateProjectPopUpAction: "create" | "clone";
	public templateProjectPopUpVisible: boolean;

	public onCreateNewTemplateProjectClicked() {
		

		this.templateProjectPopUpAction = "create";
		this.templateProjectPopUpVisible = true;
	}

	public onCloneTemplateProjectClicked() {
		

		this.templateProjectPopUpAction = "clone";
		this.templateProjectPopUpVisible = true;
	}

	public onPopUpPrimaryButtonClicked(event) {
		switch (this.templateProjectPopUpAction) {
			case "create":

				this.createTemplateProject(event);

				break;
			case "clone":

				this.cloneTemplateProject(event);

				break;
		}
	}

	public createProjectPopUpVisible: boolean;

	public onCreateProjectClicked(event: any) {
		

		this.createProjectPopUpVisible = true;
	}

	public onCreateProjectPopUpPrimaryButtonClicked(event: any) {
		

		this.createProjectFromTemplate(event);
	}

	public taskPopupOnSubmitted(event: any) {
		

		let task: TemplateProjectTask = event as TemplateProjectTask;

		

		let chartTaskIndex: number = this.templateTasks.findIndex(innerTask => innerTask.id === task.id);

		// Assigning because method copyFrom would be missing otherwise.
		let chartTask: TemplateProjectTask = Object.assign(new TemplateProjectTask(), this.templateTasks[chartTaskIndex], task);

		if (chartTask) {
			

			this.templateTasks[chartTaskIndex] = chartTask;

			this.updateResourceAssignmentOfTask(this.templateTasks[chartTaskIndex]);

			this.refreshGanttChart();
		} else {
			console.error("Couldn't find a task with this id. Tasks:", this.templateTasks);
		}
	}

	public customizeProgressText(cellInfo: any) {
		return cellInfo.value + "%";
	}

	onDragChange(e) {
		
	}

	onReorder(e) {
		

			
	}

	// </Misc>
}
